import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./lib/auth";
import { ThemeProvider } from "./lib/theme";
import { Toaster } from "sonner";
import "./App.css";

import Landing from "./pages/Landing";
import Auth from "./pages/Auth";
import ProtectedLayout from "./components/ProtectedLayout";
import Onboarding from "./pages/Onboarding";
import Dashboard from "./pages/Dashboard";
import Profile from "./pages/Profile";
import Learn from "./pages/Learn";
import ChapterReader from "./pages/ChapterReader";
import Tribunal from "./pages/Tribunal";
import Discover from "./pages/Discover";
import Practice from "./pages/Practice";
import Earn from "./pages/Earn";
import Advance from "./pages/Advance";
import Protect from "./pages/Protect";
import { StudyPathsList, StudyPathDetail } from "./pages/StudyPaths";
import Journal from "./pages/Journal";
import Digest from "./pages/Digest";
import AIStudio from "./pages/AIStudio";
import Orgs from "./pages/Orgs";
import OrgDetail from "./pages/OrgDetail";
import RoleDetail from "./pages/RoleDetail";
import Jobs from "./pages/Jobs";
import PublicPlan from "./pages/PublicPlan";

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors closeButton />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/auth" element={<Auth />} />

            <Route path="/app" element={<ProtectedLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="onboarding" element={<Onboarding />} />
              <Route path="profile" element={<Profile />} />
              <Route path="tribunal" element={<Tribunal />} />
              <Route path="discover" element={<Discover />} />
              <Route path="learn" element={<Learn />} />
              <Route path="learn/chapter/:id" element={<ChapterReader />} />
              <Route path="practice" element={<Practice />} />
              <Route path="earn" element={<Earn />} />
              <Route path="advance" element={<Advance />} />
              <Route path="protect" element={<Protect />} />
              <Route path="paths" element={<StudyPathsList />} />
              <Route path="paths/:slug" element={<StudyPathDetail />} />
              <Route path="journal" element={<Journal />} />
              <Route path="digest" element={<Digest />} />
              <Route path="studio" element={<AIStudio />} />
              <Route path="jobs" element={<Jobs />} />
              <Route path="orgs" element={<Orgs />} />
              <Route path="orgs/:id" element={<OrgDetail />} />
              <Route path="roles/:id" element={<RoleDetail />} />
            </Route>
            <Route path="/p/:slug" element={<PublicPlan />} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
